import { useEffect, useState } from 'react';
import { analyticsAPI } from '../services/api';
import './Dashboard.css';

const Dashboard = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadDashboard();
    }, []);

    const loadDashboard = async () => {
        try {
            const response = await analyticsAPI.getDashboard();
            setData(response.data);
        } catch (error) {
            console.error('Error loading dashboard:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="loading">Загрузка...</div>;
    }

    const { latestWeight, workoutsCount, totalWorkoutMinutes, healthIndex } = data || {};

    return (
        <div className="dashboard">
            <h1>Главная</h1>

            <div className="dashboard-grid">
                <div className="dashboard-card">
                    <h3>Вес</h3>
                    {latestWeight ? (
                        <div>
                            <div className="value-large">{latestWeight.weight} кг</div>
                            {latestWeight.difference !== null && (
                                <div className={`difference ${latestWeight.difference > 0 ? 'negative' : 'positive'}`}>
                                    {latestWeight.difference > 0 ? '+' : ''}{latestWeight.difference} кг
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="no-data">Нет данных</div>
                    )}
                </div>

                <div className="dashboard-card">
                    <h3>Количество тренировок</h3>
                    <div className="value-large">{workoutsCount || 0}</div>
                </div>

                <div className="dashboard-card">
                    <h3>Общее время тренировок</h3>
                    <div className="value-large">{totalWorkoutMinutes || 0} мин</div>
                </div>

                <div className={`dashboard-card health-index ${healthIndex >= 0 ? 'positive' : 'negative'}`}>
                    <h3>Индекс ЗОЖ</h3>
                    <div className="value-large">{healthIndex || 0}</div>
                    <div className="hint">Тренировки − вредные привычки (с коэффициентами)</div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
